import "./App.css";
import { Routes, Route, useLocation } from "react-router-dom";
import { Verify } from "./pages/Verify";
import { Home } from "./pages/Home";
import { Form } from "./pages/Form";
import { Ticket } from "./pages/Ticket";
import { Header } from "./Components/Header/Header";
import { Notfound } from "./pages/Notfound";
import { Footer } from "./Components/Footer/Footer";
import { Login } from "./pages/Login";
import { Onboarding } from "./pages/Onboarding";

function App() {
  const location = useLocation();
  const isLoginPage = location.pathname.startsWith("/auth");

  return (
    <div className="flex flex-col h-screen overflow-hidden">
      {!isLoginPage && <Header />}
      <div className="flex flex-1 min-h-0">
        {/* Only this region scrolls — Header stays fixed on screen.
            min-h-0 overrides the flex-item default of min-height:auto, which
            would otherwise let this div grow to fit its content instead of
            being clamped to the row's height (and scrolling internally). */}
        <div className="flex-1 min-w-0 min-h-0 overflow-y-auto flex flex-col "> 
          <div className="flex-1">
            <Routes>
              <Route path="/auth/login" element={<Login />} />
              <Route path="/auth/onboard/:token" element={<Onboarding />} />
              <Route path="/auth/verify/:token" element={<Verify />} />
              <Route exact path="/Dashboard" element={<Home />} />
              <Route exact path="/Form" element={<Form />} />
              <Route exact path="/Ticket/:ticketID" element={<Ticket />} />
              <Route path="*" element={<Notfound />} />
            </Routes>
          </div>
          {/* {!isLoginPage && (
            <Footer className="w-full bg-gray-900" />
          )} */}
        </div>
      </div>
    </div>
  );
}

export default App;
